import {Inject, Injectable, Injector, NgModule} from '@angular/core';
import {Routes, RouterModule, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
/*
IMPORTANT for okta : official doc is not valid, use
https://www.npmjs.com/package/@okta/okta-angular#usage
*/

import {
  OktaAuthModule,
  OktaCallbackComponent,
  OktaAuthGuard, OKTA_CONFIG, OKTA_AUTH, OktaAuthConfigService
} from '@okta/okta-angular';
import {AuthenticationService} from './services/authentication.service';
import {AppUser, AppUserData} from './framework/AppUser';
import {environment} from '../environments/environment';
import {OktaAuth} from '@okta/okta-auth-js';

@Injectable()
export class MyOktaAuthGuard extends OktaAuthGuard {

  public auth;
  public apiAuth;

  // oktaAuth: OktaAuth, injector: Injector, configService: OktaAuthConfigService
  constructor(@Inject(OKTA_AUTH) oktaAuth: OktaAuth, injector: Injector, apiAuth: AuthenticationService, configService: OktaAuthConfigService) {
    super(oktaAuth, injector, configService);
    this.auth = oktaAuth;
    this.apiAuth = apiAuth;
  }

  public static token = null;

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((ok, err) => {
        if (window.localStorage.getItem('cypress-okta-token')) {
          const appUserData: AppUserData = JSON.parse(window.localStorage.getItem('cypress-okta-token')) as AppUserData;
          AppUser.setData(appUserData);
          this.rightCheck(route, ok, err);
          return ok(true);
        }
        console.log('authentication: check', route, state);

        super.canActivate(route, state).then(r => {
          console.log('authentication:okta ok');
          if (r) {
            if (MyOktaAuthGuard.token === null) {
              document.getElementById('okta-message').style.display = 'block';
              console.log('authentication:using okta token');
              const token = this.auth.getAccessToken();

              console.log('token set');
              if (token) {
                this.apiAuth.loginViaOktaToken(token).then(r2 => {
                  MyOktaAuthGuard.token = r2.token;
                  // keep only groups that have QARSOD_ in them
                  const groups = [];
                  if (r2.groups) {
                    for (const g of r2.groups) {
                      if (g.indexOf('QARSOD_') !== -1) {
                        groups.push(g.replace('QARSOD_', ''));
                      }
                    }
                  }
                  if (environment.override) {
                    r2.token = environment.override.token;
                    r2.login = environment.override.login;
                    r2.groups = environment.override.groups;
                  } else {
                    r2.groups = groups;
                  }
                  AppUser.setData(r2);
                  console.log('login ok', r2);

                  this.rightCheck(route, ok, err);
                  document.getElementById('okta-message').style.display = 'none';

                  ok(true);
                }, e => {
                  if (e.status === 0) {
                    alert('Authentication server could not be reach');
                  }
                  console.log({e});
                  if (confirm('Login failed, try again ?' + (e.error?.Message ? '\r\n(' + e.error.Message : ')'))) {
                    window.localStorage.clear();
                    window.sessionStorage.clear();
                    this.deleteCookies();
                    window.location.replace(environment.okta.loginUri);
                  } else {
                    document.getElementById('okta-message').innerHTML = 'Login failed, please refresh the page to try again (' + e.message + ')';
                  }
                });
              } else {
                window.localStorage.clear();
                window.sessionStorage.clear();
                this.deleteCookies();
                window.location.replace(environment.okta.loginUri);
              }

            } else {
              console.log('token used');
              this.rightCheck(route, ok, err);
              ok(true);
            }
          } else {
            console.log('token set error', r);
            err(r);
          }
        }, e => {
          console.log('okta not ok');
          err(e);
        });
      }
    );
  }


  deleteCookies() {
    const allCookies = document.cookie.split(';');

    for (let i = 0; i < allCookies.length; i++) {
      document.cookie = allCookies[i] + '=;expires='
        + new Date(0).toUTCString();
    }

  }

  public rightCheck(route: ActivatedRouteSnapshot, ok, err) {
    if (route.data['right']) {
      console.log('checking for right', route.data);
      // e.g. ACCESS_ANOMALIES_PAGE
      if (!new AppUser().isAllowed(route.data['right'])) {
        alert('Sorry, access restricted, you need the right ' + route.data['right']);
        err('not allowed, missing right ' + route.data['right']);
      } else {
        ok(true);
      }
    }
  }
}
 